import React from 'react'
import {
  LinearProgress,
  Typography,
  Box,
  LinearProgressProps,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'

import { useCreatePropertyAdStore } from 'store'

const LinearProgressWithLabel = (
  props: JSX.IntrinsicAttributes & LinearProgressProps
) => {
  const { t } = useTranslation()

  const [steps, completedSteps] = useCreatePropertyAdStore(
    (state) => [state.steps, state.completedSteps],
    shallow
  )

  const calculatedValue = React.useMemo(
    () => Number((completedSteps?.length / (steps + 1)) * 100),
    [completedSteps, steps]
  )

  return (
    <Box sx={{ display: 'grid', alignItems: 'center' }}>
      <Typography
        variant="body2"
        fontSize={30}
        color="primary"
        sx={{ textAlign: { xs: 'center', sm: 'left' } }}
      >
        {t('manageEstateAd.percentageIsComplete', {
          percentage: Math.round(calculatedValue || 0),
        })}
      </Typography>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress
          sx={{ height: '20px', borderRadius: '10px' }}
          variant="determinate"
          value={calculatedValue}
          {...props}
        />
      </Box>
    </Box>
  )
}

export default LinearProgressWithLabel
